import { Store } from "./store.js";

export type Theme = "light" | "dark" | "system";
const KEY = "envstash-theme";

export const theme = new Store<Theme>("system");

function apply(t: Theme): void {
  const dark = t === "dark" || (t === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.classList.toggle("dark", dark);
}

export function initTheme(): void {
  let saved: Theme = "system";
  try {
    const v = localStorage.getItem(KEY);
    if (v === "light" || v === "dark" || v === "system") saved = v;
  } catch {
    // storage unavailable
  }
  theme.set(saved);
  apply(saved);
  window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
    apply(theme.get());
  });
}

export function setTheme(t: Theme): void {
  theme.set(t);
  apply(t);
  try {
    localStorage.setItem(KEY, t);
  } catch {
    // ignore
  }
}
